import React from "react";
import PropTypes from "prop-types";

import Link from "core/Link";
import PageMeta from "core/PageMeta";
import Heading from "core/Heading";
import BodyText from "core/BodyText";
import SectionContainer from "core/SectionContainer";

import {
    SUBMIT_ICONS,
    BECOME_PHOTOGRAPHER_LANDING_PAGE,
    authLinks
} from "data/links";

import { useCurrentUser } from "js/contexts/CurrentUserContext";

const NonCreatorPublicProfile = ({ userData, username }) => {
    const { isAnonymous, username: currentUserUsername } = useCurrentUser();

    const getKitsLink = () => {
        if (isAnonymous) {
            return authLinks.login.href;
        } else {
            return `/${encodeURIComponent(currentUserUsername)}/kits/`;
        }
    };

    const displayName =
        userData && userData.info && userData.info.name
            ? userData.info.name
            : username;

    return (
        <>
            <PageMeta
                noindex
                title={displayName}
                description={`${displayName} at Noun Project`}
            />
            <SectionContainer>
                <Heading size="lg" bottomSpacing="2xl" type="p">
                    {displayName} hasn't contributed icons or photos
                </Heading>
                <SectionContainer
                    topSpacing="none"
                    bottomSpacing="xl"
                    removeLeftRightPadding
                >
                    <BodyText type="p" size="xl" bold>
                        Become a Creator Now
                    </BodyText>
                    <p>
                        <Link href={SUBMIT_ICONS} size="lg" styleType="primary">
                            Submit icons
                        </Link>
                    </p>
                    <p>
                        <Link
                            href={BECOME_PHOTOGRAPHER_LANDING_PAGE}
                            size="lg"
                            styleType="primary"
                        >
                            Submit photos
                        </Link>
                    </p>
                </SectionContainer>
                <BodyText type="p" size="xl" bold>
                    Looking for your saved icons?{" "}
                    <Link href={getKitsLink()} size="xl" styleType="primary">
                        Find your kits here
                    </Link>
                </BodyText>
            </SectionContainer>
        </>
    );
};

NonCreatorPublicProfile.propTypes = {
    creatorData: PropTypes.object,
    username: PropTypes.string.isRequired
};

export default NonCreatorPublicProfile;
